import {
  avt1,
  avt2,
  avt3,
  avt4,
  bgBlueStar,
  iconNext,
} from "../assets";
import { useEffect, useState } from "react";

const Star = () => {
  // const [data, setData] = useState(dataUser);
  const [idData, setIdData] = useState(1);

  const action = (value) => {
    if (value === "left") {
      setIdData((preState) => (preState === 0 ? 3 : preState - 1));
    }
    if (value === "right") {
      setIdData((preState) => (preState === 3 ? 0 : preState + 1));
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      action("right");
    }, 30000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="w-screen h-[850px] sm:h-[750px] lg:h-[855px] flex items-center flex-col relative">
      <img
        className="object-fill absolute z-[0] w-screen h-[100%]"
        src={bgBlueStar}
        alt=""
      />
      <div className="z-[1] flex flex-col items-center mb-[70px] px-[20px]">
        <div className="font-[600] text-[#ffffff] text-[26px] sm:text-[30px] lg:text-[40px] border-b-[6px] pb-[15px] w-fit border-[#FFFFFF] mb-[20px] mt-[50px] text-center">
          Sao Việt - Life Pro
        </div>
        <div className="relative flex items-center">
          <img
            src={iconNext}
            alt=""
            className="absolute top-[50%] left-[-10px] sm:left-[-90px]  z-[5] rotate-180 translate-y-[-50%] h-[40px] sm:h-[60px] cursor-pointer"
            onClick={() => action("left")}
          />
          <div className="rounded-[50%] border-[6px] border-[#CCCCCC] mr-[-25px] z-[1] cursor-pointer">
            <img
              className="h-[108px] lg:h-[160px] rounded-[50%] brightness-[0.65]"
              src={dataUser[idData === 0 ? 3 : idData - 1].avata}
              alt=""
            />
          </div>
          <img
            className="h-[170px] lg:h-[261px] rounded-[50%] border-[6px] border-[#FFFFFF] z-[2]"
            src={dataUser[idData].avata}
            alt=""
          />
          <div className="rounded-[50%] border-[6px] border-[#CCCCCC] ml-[-25px]  z-[1] cursor-pointer">
            <img
              className="h-[108px] lg:h-[160px] rounded-[50%] brightness-[0.65]"
              src={dataUser[idData === 3 ? 0 : idData + 1].avata}
              alt=""
            />
          </div>
          <img
            src={iconNext}
            alt=""
            className="absolute top-[50%] right-[-10px]  sm:right-[-90px] z-[5] translate-y-[-50%] h-[40px] sm:h-[60px] cursor-pointer"
            onClick={() => action("right")}
          />
        </div>
        <div className="font-[600] text-[#ffffff] text-[22px] sm:text-[28px] lg:text-[32px] mt-[20px]">
          {dataUser[idData].name}
        </div>
        <div className="font-[600] text-[#ffffff] text-[16px] sm:text-[20px] lg:text-[24px] mt-[15px] text-center min-h-[48px]">
          {dataUser[idData].rank}
        </div>
        <div className="text-star mt-[15px] max-w-[1115px]">
          {dataUser[idData].detail1}
        </div>
        <div className="text-star mt-[15px] max-w-[1115px]">
          {dataUser[idData].detail2}
        </div>
        <div className="flex mt-[20px] absolute bottom-[20px]">
          <div
            className={`w-[16px] h-[16px] rounded-[50%] border border-[#ffffff] mr-[10px] ${
              idData === 0 && "bg-white"
            }`}
          />
          <div
            className={`w-[16px] h-[16px] rounded-[50%] border border-[#ffffff] mr-[10px] ${
              idData === 1 && "bg-white"
            }`}
          />
          <div
            className={`w-[16px] h-[16px] rounded-[50%] border border-[#ffffff] mr-[10px] ${
              idData === 2 && "bg-white"
            }`}
          />
          <div
            className={`w-[16px] h-[16px] rounded-[50%] border border-[#ffffff] ${
              idData === 3 && "bg-white"
            }`}
          />
        </div>
      </div>
    </div>
  );
};

export default Star;

const dataUser = [
  {
    id: 0,
    name: "Nguyễn Hồng Giang",
    avata: avt3,
    rank: "Sao Việt Hạng Vàng 2024",
    detail1:
      "Một trong những Tư vấn tài chính chuyên nghiệp xuất sắc nhất tại Bảo Việt Life Pro, gia nhập đội ngũ Kênh Life Pro từ ngày 19/10/2023, với sự nhiệt huyết, năng lực vượt trội và không ngừng khẳng định bản thân, chỉ sau ba tháng làm việc, chị đã đạt được vé tham dự chương trình “Thành công sớm - Phát triển bền” tại Thái Lan với doanh số 170 triệu đồng phí khai thác mới. Với thành tích nổi bật, chị đã vinh dự trở thành Sao Việt Hạng Vàng đầu tiên của Kênh Life Pro năm 2024.",
    detail2:
      "Sự thành công liên tục không chỉ thể hiện ở những kết quả ấn tượng mà còn được công nhận và đánh giá cao bởi Ban Lãnh đạo Công ty. Những thành tích này là minh chứng rõ nét cho sự chuyên nghiệp và nỗ lực không ngừng trong nghề nghiệp.",
  },
  {
    id: 1,
    name: "Trần Hồng Nhung",
    avata: avt1,
    rank: "Sao Việt Hạng Vàng 2022",
    detail1:
      "Một trong những cấp quản lý xuất sắc đã gia nhập Bảo Việt Life Pro vào tháng 12 năm 2021 và nhanh chóng trở thành TOP 1 Life Pro năm 2022, đạt danh hiệu Sao Việt Hạng Vàng cùng năm. Năm 2023, chị liên tục giữ vị trí TOP Life Pro ở nhiều tháng và quý. Đến tháng 8 năm 2024, sau hơn 2 năm gia nhập chị đã thăng chức lên Tiền trưởng nhóm Kênh Life Pro.",
    detail2:
      "Trước khi chuyển sang bảo hiểm, chị Nhung là quản lý khách sạn tại Hà Nội, nhưng sự ảnh hưởng của dịch Covid-19 đã dẫn chị đến lĩnh vực bảo hiểm. Với sự đam mê và kiên trì, chị đã thành công vượt trội trong ngành bảo hiểm và quyết định đảm nhận vai trò Trưởng phòng kinh doanh để dẫn dắt và hỗ trợ các bạn trẻ trong nghề.",
  },
  {
    id: 2,
    name: "Nguyễn Thu Giang",
    avata: avt2,
    rank: "Sao Việt hạng Bạch Kim 2023 - Sao Việt hạng Vàng 2024",
    detail1:
      "Một tư vấn viên xuất sắc của Bảo Việt Life Pro, gia nhập đội ngũ Kênh Life Pro từ ngày 13/7/2022. Với sự cống hiến và khả năng vượt trội, chị nhanh chóng khẳng định bản thân và đạt được nhiều thành tựu nổi bật. ",
    detail2:
      'Trong năm 2023, chị đã vinh dự nhận danh hiệu Sao Việt Hạng Vàng vào tháng 8 và tiếp tục nâng tầm thành công với danh hiệu Sao Việt Hạng Bạch Kim vào tháng 11. Đặc biệt, chị còn giành giải Nhất trong cuộc thi "Sản phẩm vững - Nghiệp vụ giỏi 2024" của Kênh Life Pro, khẳng định uy tín và thành công vượt trội. Thành tích này là minh chứng cho sự nỗ lực không ngừng nghỉ của bản thân, chị chính là hình mẫu lý tưởng về sự chuyên nghiệp và là nguồn cảm hứng lớn cho đồng nghiệp trong ngành.',
  },
  {
    id: 3,
    name: "Đinh Thị Thu Trang",
    avata: avt4,
    rank: "Sao Việt Hạng Vàng 2023",
    detail1:
      "Chị Đinh Thị Thu Trang, sinh năm 1979, hiện đang đảm nhiệm chức vụ Trưởng phòng Kinh doanh tại kênh LP. Với hơn 3 năm kinh nghiệm lãnh đạo, chị đã ghi dấu ấn mạnh mẽ khi trở thành Trưởng phòng Kinh doanh đầu tiên tại kênh LP vào thánh 7 năm 2021. Dưới sự dẫn dắt của chị, phòng Kinh doanh đã đạt được những thành tựu đáng tự hào, bao gồm việc liên tục nằm trong TOP CQL nhiều tháng và quý liên tiếp trong năm 2023.",
    detail2:
      "Chị Thu Trang không chỉ nổi bật với những thành tích cá nhân mà còn là người lãnh đạo xuất sắc. Trong 3 năm qua, chị đã tuyển dụng hơn 30 tư vấn viên mới và hỗ trợ 3 trong số họ thăng tiến lên vị trí Trưởng phòng Kinh doanh. Đặc biệt, chị đã được vinh danh với giải Sao Việt Hạng Vàng 2023, trở thành Sao việt cấp quản lý đầu tiên của kênh TVTC chuyên nghiệp Life Pro.",
  },
];
